<script setup>
import { defineProps } from 'vue';
import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoDataBase from '@/components/v2/base/CampoDataBase/CampoDataBase.vue';
import CampoCheckboxBase from '@/components/v2/base/CampoCheckboxBase/CampoCheckboxBase.vue';

defineProps({
    dado: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: true },
});
</script>

<template>
    <CartaoBase>
        <template #header>
            <span class="text-subtitle-1 font-weight-bold">Datas e Etapas</span>
        </template>

        <template #body>
            <v-row dense class="c-row">
                <v-col cols="12" md="3"><CampoDataBase label="Prev. Encerramento" :value="dado?.dataEncerramentoPrevista" disabled /></v-col>
                <v-col cols="12" md="3"><CampoDataBase label="Encerramento" :value="dado?.dataEncerramento" disabled /></v-col>
                <v-col cols="12" md="3"><CampoDataBase label="Prev. Detalhamento" :value="dado?.dataDetalhamentoPrevista" disabled /></v-col>
                <v-col cols="12" md="3"><CampoDataBase label="Detalhamento" :value="dado?.dataDetalhamento" disabled /></v-col>

                <v-col cols="12" md="3"><CampoCheckboxBase :value="dado?.possuiDetalhamento" disabled>Possui Detalhamento</CampoCheckboxBase></v-col>
                <v-col cols="12" md="3"><CampoDataBase label="Prev. Montagem" :value="dado?.dataMontagemPrevista" disabled /></v-col>
                <v-col cols="12" md="3"><CampoDataBase label="Montagem" :value="dado?.dataMontagem" disabled /></v-col>
                <v-col cols="12" md="3"><CampoCheckboxBase :value="dado?.possuiMontagem" disabled>Possui Montagem</CampoCheckboxBase></v-col>

                <v-col cols="12" md="3"><CampoDataBase label="Prev. Fabricação" :value="dado?.dataFabricacaoPrevista" disabled /></v-col>
                <v-col cols="12" md="3"><CampoDataBase label="Fabricação" :value="dado?.dataFabricacao" disabled /></v-col>
            </v-row>
        </template>
    </CartaoBase>
</template>

<style scoped>
.c-row {
    margin: 0 !important;
}
</style>
